import { useEffect } from "react";
import "./App.css";
import "./funnel.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Funnel from "./pages/Funnel";
import Admin from "./pages/Admin";
import Diagnostic from "./pages/Diagnostic";
import Recording from "./pages/Recording";
import IntakePortal from "./pages/IntakePortal";
import BookReading from "./pages/BookReading";

function FontLoader() {
  useEffect(() => {
    if (document.getElementById("space-funnel-fonts")) return;
    const pre1 = document.createElement("link");
    pre1.rel = "preconnect";
    pre1.href = "https://fonts.googleapis.com";
    document.head.appendChild(pre1);
    const pre2 = document.createElement("link");
    pre2.rel = "preconnect";
    pre2.href = "https://fonts.gstatic.com";
    pre2.crossOrigin = "anonymous";
    document.head.appendChild(pre2);
    const link = document.createElement("link");
    link.id = "space-funnel-fonts";
    link.rel = "stylesheet";
    link.href =
      "https://fonts.googleapis.com/css2?family=Cinzel:wght@500;600;700;900&family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Inter:wght@400;500;600;700&display=swap";
    document.head.appendChild(link);
  }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <FontLoader />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Funnel />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/diagnostic/:token" element={<Diagnostic />} />
          <Route path="/recording/:token" element={<Recording />} />
          <Route path="/intake" element={<IntakePortal />} />
          <Route path="/diakonia" element={<IntakePortal />} />
          <Route path="/book-reading" element={<BookReading />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
